import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { initAnalytics, trackPageView } from "./analytics";


const TRACKING_ID = "G-E2RGDN96J7";

function AnalyticsHandler() {
  const location = useLocation();

  const consent = localStorage.getItem("analyticsConsent") == "true";

  useEffect(() => {
    initAnalytics(TRACKING_ID, consent);
  }, [consent]);


  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
};

export default AnalyticsHandler;